import React from 'react'
import classnames from 'classnames'

export interface ISnackbar {
  text: string
  type?: 'informative' | 'error' | 'success'
  icon?: boolean
  lineHeight?: 'tight' | 'normal' | 'relaxed' | 'loose'
  className?: string
  onClose?: React.MouseEventHandler<HTMLButtonElement>
}

const Snackbar = ({
  text,
  type = 'informative',
  icon,
  lineHeight = 'tight',
  className,
  onClose,
}: ISnackbar) => {
  return (
    <div
      className={classnames(
        `${className} relative flex w-full items-center rounded-lg py-4 pl-4 font-spaceGrotesk font-normal`,
        {
          'bg-main-blue bg-opacity-20 text-main-blue': type === 'informative',
          'bg-red bg-opacity-20 text-red': type === 'error',
          'bg-green bg-opacity-20 text-green': type === 'success',
        },
      )}>
      {icon && <span className="icon-edit inline-block pr-2 text-lg"></span>}
      <span className={classnames(`leading-${lineHeight}`, { 'pr-12': onClose, 'pr-4': !onClose })}>
        {text}
      </span>
      {onClose && (
        <span onClick={onClose} className="icon-close ml-auto inline-block pr-4 text-lg"></span>
      )}
    </div>
  )
}

export default Snackbar
